import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Table } from 'antd'
import { useFetchPractices, usePractices } from '../../redux/slices/practices'
import { useAsync, useIsMobile } from '../../hooks'
import { teamShape } from '../prop-types'
import SelectTeam from './SelectTeam'
import PracticeMobileCard from './PracticeMobileRow'

function Practices({ teams }) {
  const isMobile = useIsMobile()
  const { pending } = useAsync(useFetchPractices('all', true))
  const practices = usePractices()

  const columns = useMemo(
    () => [
      {
        title: 'Name',
        dataIndex: 'name',
        width: '50%',
        editable: true,
      },
      {
        title: 'Teams',
        dataIndex: 'teams',
        render(_text, record) {
          return <SelectTeam teams={teams} practice={record} />
        },
      },
    ],
    [teams],
  )

  // On mobile the two columns stack into one card per practice: the name on
  // top and the team picker at full width underneath, instead of a multi-select
  // squeezed into half a phone screen. No expand toggle is needed because both
  // desktop columns are on the card.
  const mobileColumns = useMemo(
    () => [
      {
        title: 'Practice',
        key: 'practice',
        render(_text, record) {
          return <PracticeMobileCard practice={record} teams={teams} />
        },
      },
    ],
    [teams],
  )

  return (
    <Table
      size={isMobile ? 'small' : 'middle'}
      rowKey="id"
      columns={isMobile ? mobileColumns : columns}
      showHeader={!isMobile}
      dataSource={practices}
      loading={pending}
    />
  )
}

Practices.propTypes = {
  teams: PropTypes.arrayOf(teamShape).isRequired,
}

export default Practices
